import {createStore} from 'zustand-x';

export type MiscState = {
    isConnected: boolean,
}

const initialState: MiscState = {
    isConnected: false,
}

export const miscSlice = createStore(initialState, {name: 'misc'});